module.exports = __webpack_public_path__ + "img/cinnamon-bun.491516ca.png";